// extracted by mini-css-extract-plugin
module.exports = {"bodyStyle":"CallReport-module--bodyStyle--1DfuP","fixHeader":"CallReport-module--fixHeader--2JJK9"};